<template>
  <div class="guide" :style="styleLine">
    <div class="guide-message">
      <div class="header">
        <div class="title">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.02311 5C7.36526 5 6.85645 5.45433 6.85645 6.16635C6.85645 6.44249 6.63259 6.66635 6.35645 6.66635C6.0803 6.66635 5.85645 6.44249 5.85645 6.16635C5.85645 4.86625 6.84946 4 8.02311 4C9.24842 4 10.2701 4.87515 10.2701 6.16635C10.2701 6.63873 10.0723 7.03866 9.8485 7.34916C9.62544 7.65868 9.34929 7.91638 9.13981 8.10543C8.6614 8.53716 8.52343 9.01099 8.52344 9.49999C8.52344 9.77613 8.29959 9.99999 8.02345 10C7.74731 10 7.52344 9.77616 7.52344 9.50001C7.52342 8.7814 7.74469 8.01744 8.46985 7.36303C8.67483 7.17805 8.88129 6.98088 9.03722 6.7645C9.19246 6.54909 9.27006 6.3521 9.27006 6.16635C9.27006 5.48981 8.76064 5 8.02311 5ZM8.02344 11C7.74729 11 7.52344 11.2239 7.52344 11.5C7.52344 11.7761 7.74729 12 8.02344 12C8.29958 12 8.52344 11.7761 8.52344 11.5C8.52344 11.2239 8.29958 11 8.02344 11Z"
              fill="#E2E2E2" />
          </svg>
          <span class="title-content">{{ title }}</span>
        </div>
        <div class="close" @click="close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.35355 1.64645C2.15829 1.45118 1.84171 1.45118 1.64645 1.64645C1.45118 1.84171 1.45118 2.15829 1.64645 2.35355L7.29289 8L1.64645 13.6464C1.45118 13.8417 1.45118 14.1583 1.64645 14.3536C1.84171 14.5488 2.15829 14.5488 2.35355 14.3536L8 8.70711L13.6464 14.3536C13.8417 14.5488 14.1583 14.5488 14.3536 14.3536C14.5488 14.1583 14.5488 13.8417 14.3536 13.6464L8.70711 8L14.3536 2.35355C14.5488 2.15829 14.5488 1.84171 14.3536 1.64645C14.1583 1.45118 13.8417 1.45118 13.6464 1.64645L8 7.29289L2.35355 1.64645Z"
              fill="#E2E2E2" />
          </svg>
        </div>
      </div>
      <div class="content">
        {{ content }}
      </div>
      <div class="content-link">
        <a :href="link" target="_blank"> READ GUIDELINE </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { cloneDeep } from '@/utils/common';
import { app } from '@/store';
import { mapActions, mapState } from 'vuex';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'GuideCustomizeStyle',
  props: {
    styleLine: {
      type: Object,
    },
    title: {
      type: String,
      default: 'Customize styles',
    },
    content: {
      type: String,
      default: 'Learn how to use Preset to customize your pages',
    },
    link: {
      type: String,
      default: '#',
    },
    guide: {
      type: String,
    },
  },
  computed: {
    ...mapState('app', {
      shopMeta: 'shopMeta',
    }),
  },
  methods: {
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    close() {
      this.handleClose();
    },
    handleClose() {
      if (!this.guide) return;
      const payload = cloneDeep(this.shopMeta);
      payload.onboardingGlobalStyle[this.guide] = true;
      (app as any).$store.state['app']['shopMeta']['onboardingGlobalStyle'][this.guide] = true;
      this.updateShopMeta(payload);
    },
  },
});
</script>

<style lang="scss" scope>
.guide {
  z-index: 8;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  margin-bottom: 8px;
  margin-top: 8px;
}

.guide-message {
  border: 1px dashed #323232;
  box-sizing: border-box;
  border-radius: 3px;
  background: #252525;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #e2e2e2;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
  }

  .title {
    padding-left: 13px;
    display: flex;

    &-content {
      margin-left: 8px;
    }
  }

  .close {
    padding-right: 13px;
    cursor: pointer;
  }

  .content {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #e2e2e2;
    padding-left: 36px;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-right: 35px;
  }

  .content-link {
    padding-left: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    margin-top: 8px;
    margin-bottom: 8px;

    a {
      color: #7190ff;
    }
  }
}
</style>
